<template>
      <div class="create-form--container fh center h-100 w-100" v-if="loading">
         <loading-circle />
      </div>
  <div v-else >
    <div class="project-form" >
      <h3 v-if="!bomList">{{ formTemplateData.name }}</h3>
    <div>
      <!-- // click.stop is to handle clickoutside -->
        <div class="create-form--container" @click.stop>
        <div class="create-form--elements">
          <div class="create-form-autogenerated">
            <div class="material-row">
              <span class="label">Material name:</span>
              <span class="value elipsis-text" v-overflow-tooltip>{{ createMaterialValues.material_name }}</span>
            </div>
            <div class="material-row">
                <span class="label">Material id:</span>
                <span class="value elipsis-text" v-overflow-tooltip>{{ createMaterialValues.custom_material_id }}</span>
              </div>
          </div>
          <div class="view-form">
            <div class="form-grid mt-2">
              <template v-for="(ele, index) in templateField">
                <div :key="index" v-if="!ele.autogenerated" :class="['form-grid__item','form-grid__item--span-2']">
                  <component
                    :ref="ele.field_id"
                    :is="ele.form_field.key + '_COMPONENT'"
                    :mode="!formValueData ? 'CREATE' : 'EDIT'"
                    :data="ele"
                    :viewOnly="bomList"
                    :value="!formValueData ? null : formValueData[ele.field_id]"
                    :returnObjectValue="true"
                    :formTemplate="true"
                  />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
  </div>
      <div class="action-btn" v-if="!bomList">
        <button type="button" class="btn btn-cancel mx-2" @click="cancel">
          Cancel
        </button>
        <button type="button" class="btn"  @click="submitForm"> {{ formValueData === null ? 'SAVE' : 'UPDATE' }}</button>
      </div>
    </div>
    </div>
  </template>

<script>
import { mapGetters } from 'vuex'
import { getDetailFormTemplate, GetFormDataByFormId, getGivenCustomListsData } from '@/api'
import spinner from '@/components/common/spinner.vue'
import timeComponent from '@/components/form/elements/timeComponent.vue'
import configurationList from '@/components/form/elements/configurationList.vue'
import fileComponent from '@/components/form/elements/fileComponent.vue'
import dateComponent from '@/components/form/elements/dateComponent.vue'
import longTextComponent from '@/components/form/elements/longTextComponent.vue'
import numberComponent from '@/components/form/elements/numberComponent.vue'
import switchComponent from '@/components/form/elements/switchComponent.vue'
import textComponent from '@/components/form/elements/textComponent.vue'
import companyComponent from '@/components/form/elements/companyComponent.vue'
import userComponent from '@/components/form/elements/userComponent.vue'
import multiUserComponent from '@/components/form/elements/multiUserComponent.vue'
import materialComponent from '@/components/form/elements/materialComponent.vue'
import locationComponent from '@/components/form/elements/locationComponent.vue'
import productCodeComponent from '@/components/form/elements/productCodeComponent.vue'
import LoadingCircle from '../../../components/common/loadingCircle.vue'
import tableTemplate from '../../SETTINGS/tableTemplate.vue'
import { GetFormValueMap } from '@/helper/formValue.js'
import { GetTenantConfigTypes } from '@/api/apis/tenantConfigFeature'
import config from '../../../config'
// import { GetTenantConfigTypes } from '@/api/apis/tenantConfigFeature'

export default {
  name: 'create-material-form',
  components: {
    spinner,
    BOOLEAN_COMPONENT: switchComponent,
    NUMBER_COMPONENT: numberComponent,
    TEXT_COMPONENT: textComponent,
    LONG_TEXT_COMPONENT: longTextComponent,
    DATE_COMPONENT: dateComponent,
    TIME_COMPONENT: timeComponent,
    CONFIGURATION_LIST_COMPONENT: configurationList,
    ATTACHMENT_COMPONENT: fileComponent,
    COMPANY_COMPONENT: companyComponent,
    USER_COMPONENT: userComponent,
    MULTI_USER_COMPONENT: multiUserComponent,
    MATERIALS_COMPONENT: materialComponent,
    LOCATION_COMPONENT: locationComponent,
    PRODUCT_CODE_COMPONENT: productCodeComponent,
    TABLE_COMPONENT: tableTemplate,
    LoadingCircle
  },
  data () {
    return {
      templateId: null,
      dueDate: null,
      formTemplateData: {},
      loading: true,
      formValueData: null,
      validationErrors: '' // this is for getting valiadtion errors
    }
  },
  props: {
    createMaterialValues: {
      type: Object,
      default: null
    },
    bomList: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['isOnProjectLevel', 'tenantDefaultsData']),
    templateField () {
      if (!this.formTemplateData.template_versions) return []
      const activeVersion =
        this.formTemplateData.template_versions.find((item) => item.active) ||
        {}
      return activeVersion.template_fields || []
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    getFormTemplateData () {
      this.loading = true
      getDetailFormTemplate(this.templateId).then((res) => {
        this.formTemplateData = res.core_form_templates_by_pk
        const customListData = this.findUsedCustomListIds(res.core_form_templates_by_pk.template_versions)
        if (customListData.size > 0) {
          this.getGivenCustomList([...customListData])
        }
        this.loading = false
      }).catch((err) => {
        console.error('Error fetching template data', err)
        this.loading = false
      })
    },
    findUsedCustomListIds (templateVersions) {
      const configIdSet = new Set()
      for (const templateVersion of templateVersions) {
        for (const field of templateVersion.template_fields) {
          if (field.field_type_id === config.FORM_TYPE.CONFIGRATION_LIST) {
            configIdSet.add(field.custom_list_id)
          }
        }
      }
      return configIdSet
    },
    async getGivenCustomList (ids) {
      const customListData = await getGivenCustomListsData(ids)
      const customListMap = {}
      for (const customList of customListData.core_custom_list) {
        customListMap[customList.id] = customList.custom_list_values
      }
      this.$store.dispatch('form/saveCustomListMap', customListMap)
    },
    async submitForm () {
      const form = this.$refs
      const formValue = {}
      for (const key of Object.keys(form)) {
        const field = form[key]?.[0]
        const component = field?.data
        if (!field || !component) continue
        this.validateInputData(form[key][0]?.data, form)
        if (form[key].length && form[key][0]?.data?.autogenerated === false) {
          formValue[key] = form[key][0].componentValue
        }
        if (component?.key === 'TABLE' || component?.form_field?.key === 'TABLE') {
          const isTableValid = await field.saveFormTemplate()
          if (!isTableValid) return false
        }
      }
      const inputPayload = {}
      Object.keys(formValue).forEach((key) => {
        if (formValue[key] !== undefined && formValue[key] !== null) {
          if (formValue[key] !== 0 && formValue[key].length !== 0) {
            inputPayload[key] = formValue[key]
          }
        }
      })
      this.$emit('create-material', inputPayload)
    },
    validateInputData (formInput, form) {
      if (!formInput) return
      if (formInput?.form_field?.key === 'USER') {
        if (formInput.required && (!form[formInput.field_id][0].componentValue || !form[formInput.field_id][0].componentValue.length)) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
        }
      }
      if (formInput?.form_field?.key === 'BOOLEAN') {
        // we are comparing the value to null instead of checking if it is a falsy value cause the boolean component value will false in one case and it is valid value
        if (formInput.required && form[formInput.field_id][0].componentValue === null) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
        }
        return
      } else if (formInput?.form_field?.key === 'MATERIALS') {
        if (formInput.required && form[formInput.field_id][0].componentValue.length < 1) {
          this.validationErrors.push(`${formInput.caption} is a mandatory field`)
        }
        return
      }
      if (formInput.required && !form[formInput.field_id][0].componentValue) {
        this.validationErrors.push(`${formInput.caption} is a mandatory field`)
      }
    },
    async getSTFtempId () {
      if (this.tenantDefaultsData?.material_temp_id) {
        this.templateId = this.tenantDefaultsData.material_temp_id
        return
      }
      const res = await GetTenantConfigTypes()
      const tenantDefaults = res.tenant_defaults?.[0]
      this.$store.commit('setTenentDefaults', tenantDefaults)
      this.templateId = tenantDefaults.tenant_feature_configuration.MATERIAL?.FORM_TEMPLATE_DEFAULT
    }
  },

  async mounted () {
    await this.getSTFtempId()
    await this.getFormTemplateData()
    if (this.createMaterialValues && this.createMaterialValues.overridden_material_fields) {
      this.formValueData = this.createMaterialValues.overridden_material_fields
    } else if (this.createMaterialValues && this.createMaterialValues.formId !== null && this.createMaterialValues.formId !== undefined) {
      await GetFormDataByFormId(this.createMaterialValues.formId, this.isOnProjectLevel).then(
        (res) => {
          const formData = GetFormValueMap(res.core_forms_by_pk)
          this.formValueData = formData
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped >
  .project-form {
    padding: 12px;
    font-size: var(--text-s);
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 10px;
    width: 45vw;
    max-width: 610px;
    min-width: 400px;
    h3 {
      font-size: var(--text-2xl);
      font-weight: 500;
    }
  }
  .action-btn {
    display: flex;
    padding: 20px;
    // padding-left: 14rem;// what is this Rubiya?
    justify-content: right;
  }
  .create-form {
  &--nav {
    height: 60px;
    margin: -12px;
    padding: 0 20px;
    margin-bottom: 0;
    background: var(--bg-color);
    border-bottom: var(--border);
    & input {
      border: var(--border);
      background-color: transparent;
      border-radius: 4px;
      padding: 4px 8px;
      height: 30px;
      width: 500px;
      outline: none;
      &:focus {
        border-color: var(--brand-color);
      }
    }
  }
  &--container {
    margin: 0 auto;
    overflow-y: auto;
    border-radius: 6px;
    min-width: 500px;

  // @media (max-height: 650px) {
  //   height: 362px;
  // }

  // @media (min-height: 651px) and (max-height: 750px) {
  //   height: 434px;
  // }

  // @media (min-height: 751px) and (max-height: 850px) {
  //   height: 492px;
  // }

  // @media (min-height: 851px) {
  //   height: 300px;
  // }
  }
  &--elements {
    overflow-y: auto;
    padding: 4px;
  }
  &-autogenerated {
    background-color: rgba(var(--brand-rgb), 0.2);
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    grid-gap: 10px;
    & .label {
      font-size: var(--text-base);
      color: var(--brand-color-1);
      font-weight: 500;
      flex-shrink: 0;
    }
    & .value {
      margin-left: 6px;
      font-size: var(--text-l);
      color: var(--text-color);
      max-width: 114px;
    }
  }
}
.material-row {
  display: flex;
  align-items: center;
}
  </style>
